window.storeApps = {

    init: function () {

        $('.pluginSearch-TEXT').on("keyup", function (e) {
        
            $('.pluginContainer .placeholder').hide();

            var containerToSearch = $('.pluginContainer');
            var search = $(this).val();

            if (search.length >= 1) {
                containerToSearch.find('.pluginSearchable h3').not(":insensitivecontains('" + search + "')").closest('.pluginCard').hide();
                containerToSearch.find(".pluginSearchable h3:insensitivecontains('" + search + "')").closest('.pluginCard').show();
            }

            else if (search.length < 1) {
                containerToSearch.find('.pluginCard.pluginSearchable').show();
            }

            if ($('.pluginCard:visible').length == 0) {
                
                $('.pluginContainer .placeholder').show()
            }
        });
    },

    filter: function (param) {
        
        $('.pluginContainer .placeholder').hide();
        $('.pluginCat li .pluginSearchEnabled').addClass('gray-100' );
        $('.pluginCat li .pluginSearchEnabled[data-search="' + param + '"]').removeClass('gray-100' );
        $('.pluginCard').hide().removeClass('pluginSearchable');

        switch (param) {
            case 'all':
                $('.pluginCard').fadeIn().addClass('pluginSearchable');
                break;

            case 'enabled':
                $('.pluginCard[data-storeEnabled="Y"]').fadeIn().addClass('pluginSearchable');
                break;

            case 'disabled':
                $('.pluginCard[data-storeEnabled="N"]').fadeIn().addClass('pluginSearchable');
                break;

            default:
                $('.pluginCard[data-storeCategory="' + param + '"]').fadeIn().addClass('pluginSearchable');
                break;
        }

        $('.pluginSearch-TEXT').trigger('keyup');

        if ($('.pluginCard:visible').length == 0) {
            $('.pluginContainer .placeholder').show()
        }

    },

    disablePluginError : function(e,erroMessage) {
        e.preventDefault();
        MyWindow.alert(erroMessage);
    },

    load: function (name, context) {

        var context = context == undefined ? 'click' : context;

        var options = {
            dialogClass: "upsalePopup white no-title",
            title: "",
            width: 1000,
            height : 560,
            callback: function () { }
        };

        MyWindow.load("upsale", { action: "loadFromIntroName", name: name, context: context }, options);
    }

};
